const GTranslate = () => {
    const init = select => {
        function resizeSelect(el) {
            if (!el || !el.options.length) return;

            const temp = document.createElement('span');
            temp.style.visibility = 'hidden';
            temp.style.whiteSpace = 'nowrap';
            temp.style.position = 'absolute';
            temp.style.font = getComputedStyle(el).font;

            temp.textContent = el.options[el.selectedIndex].text;

            document.body.appendChild(temp);
            const width = temp.offsetWidth;
            document.body.removeChild(temp);

            el.style.width = width + 'px';
        }

        const placeholder = select.querySelector('option[value=""]');
        if (placeholder) placeholder.remove();

        resizeSelect(select);
        select.addEventListener('change', () => resizeSelect(select));
    };

    const existing = document.querySelector('.gt_selector');

    if (existing) {
        init(existing);
        return;
    }

    const observer = new MutationObserver(() => {
        const select = document.querySelector('.gt_selector');
        if (!select) return;

        observer.disconnect();
        init(select);
    });

    observer.observe(document.body, { childList: true, subtree: true });
};

export default GTranslate;
